import request from '@/plugin/axios'

export function ListLbRefs (data) {
  return request({
    url: '/lb-ref/index',
    method: 'get',
    params: data
  })
}

export function GetAssistItems () {
  return request({
    url: '/lb-ref/assist-items',
    method: 'get'
  })
}

export function ViewLbRef (id) {
  return request({
    url: '/lb-ref/view?id=' + id,
    method: 'get'
  })
}

export function UpdateLbRef (data) {
  return request({
    url: '/lb-ref/update?id=' + data.id,
    method: 'post',
    data
  })
}

export function DownloadTemplate (data = {}) {
  return request({
    url: '/lb-ref/download-excel-tpl',
    method: 'post',
    data,
    responseType: 'blob'
  })
}

export function ExportLbRefs (data) {
  return request({
    url: '/lb-ref/export',
    method: 'post',
    data,
    responseType: 'blob'
  })
}
